module.exports = __webpack_public_path__ + "img/two.0778d326.png";